import React from 'react'
import Grid from '@material-ui/core/Grid'
import { Field } from 'react-final-form'
import { CrudForm, useEntityManager } from 'elentari'
import analistaUnidadeNegocioRepository from './analistaUnidadeNegocioRepository'
import UsuarioAutocomplete from '../../Usuarios/UsuarioAutocomplete'

const validate = data => {
  return {
    analistaId: data.analistaId ? undefined : 'Obrigatório'
  }
}

const AnalistaUnidadeNegocioForm = props => {
  const entityManager = useEntityManager({
    repository: analistaUnidadeNegocioRepository
  })
  const handleSubmit = data => {
    const unidadeNegocioId = parseInt(props.match.params.id)
    return entityManager.onSubmit({
      ...data,
      unidadeNegocioId
    })
  }
  return (
    <CrudForm
      {...props}
      {...entityManager}
      onSubmit={handleSubmit}
      validate={validate}
      withPaper
    >
      <Grid container spacing={2}>
        <Grid item sm={6} xs={12}>
          <Field
            fullWidth
            label="Analista"
            name="analistaId"
            realm="analistaadmin"
            component={UsuarioAutocomplete}
          />
        </Grid>
      </Grid>
    </CrudForm>
  )
}

export default AnalistaUnidadeNegocioForm
